<template>
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.23001 20.625C3.61488 20.625 3.12 20.1652 3.12 19.5938C3.12 19.0223 3.61488 18.5625 4.23001 18.5625H19.77C20.3851 18.5625 20.88 19.0223 20.88 19.5938C20.88 20.1652 20.3851 20.625 19.77 20.625H4.23001ZM12.8094 14.7984C12.6013 15.0047 12.3053 15.125 12 15.125C11.6948 15.125 11.4034 15.009 11.1906 14.7984L5.27063 8.95469C4.84975 8.53789 4.87288 7.88906 5.31688 7.49805C5.76088 7.10703 6.46388 7.12852 6.88475 7.54102L10.89 11.4941V7.90625V2.40625C10.89 1.83477 11.3849 1.375 12 1.375C12.6151 1.375 13.11 1.83477 13.11 2.40625V7.90625V11.4941L17.1106 7.54531C17.5315 7.12852 18.2345 7.11133 18.6785 7.50234C19.1225 7.89336 19.1456 8.54648 18.7248 8.95898L12.8048 14.8027L12.8094 14.7984Z" />
  </svg>
</template>
